import Cell from "./Cell.js";
import Vector3 from "./Utils/Vector3.js";
import Prototype from "./Prototype/Prototype";
import cell from "./Cell.js";
import PrototypeManager from "./Prototype/PrototypeManager";

export default class Map3D {
  /**
   * Size of the map in cells unit
   * @type {Vector3} mapSize
   */
  private readonly _mapSize: Vector3;

  /**
   * Prototype manager
   * @type {PrototypeManager}
   */
  private readonly prototypeManager: PrototypeManager;

  /**
   * 3D map of cells
   * @type {Cell[][][]}
   */
  private readonly _map: Cell[][][];

  constructor(mapSize: Vector3, prototypeManager: PrototypeManager) {
    this._mapSize = mapSize;
    this._map = [];
    this.prototypeManager = prototypeManager;
    this.initEmptyMap();
  }

  /**
   * init 3d map (3d empty matrice of mapSize)
   */
  initEmptyMap(): void {
    // init 3d map, 3d matrice of mapSize
    for (let x = 0; x < this._mapSize.x; x++) {
      this._map[x] = [];
      for (let y = 0; y < this._mapSize.y; y++) {
        this._map[x][y] = [];
        for (let z = 0; z < this._mapSize.z; z++) {
          this._map[x][y][z] = new Cell(
            new Vector3(x, y, z),
            this.prototypeManager,
          );
        }
      }
    }
  }

  /**
   * Set the map cell at the given tilePosition
   * @param { Cell } cell
   * @param { Vector3 } position
   */
  setCellAt(cell: Cell, position: Vector3): void {
    this._map[position.x][position.y][position.z] = cell;
  }

  /**
   * Get the map cell at the given tilePosition
   * @param { Vector3 } coords
   * @returns { Cell }
   */
  getCellAt(coords: Vector3): Cell {
    if (!this.isCoordsValid(coords)) {
      throw new Error(`Invalid coords ${coords}`);
    }

    return this._map[coords.x][coords.y][coords.z];
  }

  /**
   * Return false if the coords are out of the map
   * @param {Vector3} coords
   * @returns {boolean}
   */
  isCoordsValid(coords: Vector3): boolean {
    return (
      coords.x >= 0 &&
      coords.x < this._mapSize.x &&
      coords.y >= 0 &&
      coords.y < this._mapSize.y &&
      coords.z >= 0 &&
      coords.z < this._mapSize.z
    );
  }

  /**
   * Clear the map
   */
  clear(): void {
    this.initEmptyMap();
  }

  //// Getters

  get mapSize(): Vector3 {
    return this._mapSize;
  }

  get map(): Cell[][][] {
    return this._map;
  }
}
